import { render } from "./commonLoader.vue?vue&type=template&id=33b465d2&ts=true"
import script from "./commonLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonLoader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33b465d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33b465d2', __exports__)) {
    api.reload('33b465d2', __exports__)
  }
  
  module.hot.accept("./commonLoader.vue?vue&type=template&id=33b465d2&ts=true", () => {
    api.rerender('33b465d2', render)
  })

}


export default __exports__